// extracted by mini-css-extract-plugin
export var calendarView = "_kx-0";